import { hotRanks } from '@/mocks/kanliao';

const barColors = ['bg-orange-500', 'bg-amber-400', 'bg-yellow-300'];

export default function HotRank() {
  const max = hotRanks[0] ? hotRanks[0].viewers : '1';
  const toNum = (v: string) => Number(v.replace(/[^0-9.]/g, ''));

  return (
    <section id="hot" className="mx-auto w-full max-w-[1200px] px-4 py-12 md:px-6">
      <div className="flex flex-col gap-1 md:flex-row md:items-end md:justify-between">
        <div>
          <span className="text-xs font-semibold tracking-wide text-orange-500">REAL-TIME</span>
          <h2 className="mt-1 text-2xl font-black tracking-tight text-stone-900 md:text-3xl">
            此刻最热的直达入口
          </h2>
          <p className="mt-2 text-sm text-stone-500">
            按近期浏览量排出来的榜单，点榜名就能直达，追热点不用再搜。
          </p>
        </div>
        <button
          type="button"
          className="mt-3 inline-flex w-fit items-center gap-1 whitespace-nowrap rounded-md border border-stone-200 bg-white px-3 py-1.5 text-xs text-stone-500 transition-colors hover:border-orange-300 hover:text-orange-600 md:mt-0"
        >
          查看完整榜
          <i className="ri-arrow-right-line" />
        </button>
      </div>

      <div className="mt-6 overflow-hidden rounded-2xl border border-stone-200/80 bg-white/90">
        {hotRanks.map((r, i) => {
          const w = Math.round((toNum(r.viewers) / toNum(max)) * 100);
          const rankColor =
            r.rank === 1 ? 'text-orange-600' : r.rank === 2 ? 'text-amber-500' : 'text-stone-300';
          return (
            <a
              key={r.rank}
              href="#hot"
              className="flex items-center gap-3 border-b border-stone-100 px-4 py-3 transition-colors last:border-0 hover:bg-amber-50/50 md:gap-4 md:px-5"
            >
              <span className={`w-7 shrink-0 text-center font-black ${rankColor}`}>
                {String(r.rank).padStart(2, '0')}
              </span>
              <span className="flex w-40 shrink-0 flex-col">
                <span className="flex items-center gap-1.5 truncate text-sm font-semibold text-stone-800">
                  {r.name}
                  <i
                    className={`ri-fire-fill text-xs ${
                      r.rank <= 3 ? 'text-orange-400' : 'text-stone-200'
                    }`}
                  />
                </span>
                <span className="text-xs text-stone-400">{r.tag}</span>
              </span>

              <span className="hidden min-w-0 flex-1 sm:block">
                <span className="block h-1.5 w-full overflow-hidden rounded-full bg-stone-100">
                  <span
                    className={`block h-full rounded-full ${barColors[i] ?? 'bg-stone-300'}`}
                    style={{ width: `${w}%` }}
                  />
                </span>
              </span>

              <span className="ml-auto flex shrink-0 items-center gap-2 text-xs text-stone-400">
                <span className="whitespace-nowrap">{r.viewers} 人在线</span>
                <span className="hidden items-center whitespace-nowrap text-emerald-500 md:inline-flex">
                  <i className={`ri-arrow-up-line ${r.trend === 0 ? 'text-stone-300' : ''}`} />
                  {r.trend === 0 ? '持平' : `${r.trend}%`}
                </span>
              </span>
            </a>
          );
        })}
      </div>
    </section>
  );
}